// textNode.js

import { EnhancedTextNode } from './EnhancedTextNode';

export const TextNode = EnhancedTextNode;
